import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { setPlayerSettings } from '../store/entities/player-settings-slice';
import musicPlayer from '../services/audio/music-player';
import useTabVisibility from '../hooks/useTabVisibility';
import soundFxPlayer from '../services/audio/soundfx-player';
//import { setMusicVolume } from '../store/entities/game-controls/music-volume-slice';

export default function MusicSwitch({ className, onToggle  }) {
  const playerSettings = useSelector(s => s.playerSettings);
  const volume = useSelector(s => s.musicVolume);
  useTabVisibility();

  const isTabActive = useSelector((state) => state.activeTab);

  const musicOn = "img/controls/music-on-icon.svg";
  const musicOff = "img/controls/music-off-icon.svg";
  
  //const dispatch = useDispatch();

  const handleMusicToggle = (vol) => {
    // if (!vol) {
    //   dispatch(setMusicVolume(0.085))
    //   musicPlayer.volume('rr_trafficambience_loop',0.085);
    // }
    soundFxPlayer.play("btnClick")
    onToggle()
  };

  useEffect(() => {
    if (playerSettings.music_enabled) {
      if (isTabActive) {
        musicPlayer.loop('rr_trafficambience_loop', true);
        musicPlayer.play('rr_trafficambience_loop');
      } else {
        musicPlayer.stop('rr_trafficambience_loop');
      }
    } else {
      musicPlayer.stop('rr_trafficambience_loop');
    }
  },[playerSettings.music_enabled, isTabActive]);

  useEffect(() => {
    if (isTabActive) {
     soundFxPlayer.setGlobalVolume(soundFxPlayer.volumeLevel)
    } else {
      soundFxPlayer.setGlobalVolume(0)
    }
  }, [isTabActive]);
  
  return (
    <div onClick={handleMusicToggle} style={{ cursor: 'pointer' }} className={className}>
      <img 
        width={24} 
        height={24} 
        src={volume ? musicOn : musicOff}  
        // alt={playerSettings.music_enabled ? "music-on-icon" : "music-off-icon"} 
        alt={volume ? "music-on-icon" : "music-off-icon"} 
      />
    </div>
  );
}
